<template>
  <div class="showVConsole">
    <p v-if="show">showVConsole OK,reload Page.</p>
  </div>
</template>
<script>
import moment from "moment";
export default {
  data() {
    return {
      show: false
    };
  },
  created() {
    window.localStorage.setItem(
      "showVConsole",
      JSON.stringify({ show: 1, time: moment().unix() })
    );
    this.show = true;
  }
};
</script>
